import { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { API } from "../../utils/AxiosInstance";

export function CoachMeeting() {
    const { meetingId, token } = useParams<{
        meetingId: string;
        token: string;
    }>();

    useEffect(() => {
        async function signInToApp() {
            try {
                const { data } = await API.post<{ token: string; url: string }>(
                    "/sessions/sign_into_meeting",
                    {
                        meeting_id: meetingId,
                        token_id: token,
                    }
                );
                localStorage.setItem("token", data.token);
                window.location.href = data.url;
            } catch {
                window.location.href = "/";
            }
        }

        void signInToApp();
    }, [meetingId, token]);

    return (
        <div className="d-flex justify-content-center align-items-center p-3">
            <Spinner animation="border" />
        </div>
    );
}
